<template>
  <b-table
    :data="boxscore"
    :row-class="(row, index) => ({
      'is-hidden': row.Name === null,
      'muted': row.MIN === 0,
    })"
    header-class="header"
    hoverable
    striped
    default-sort-direction="desc"
    default-sort="MIN"
  >
    <template slot-scope="props">
      <b-table-column
        v-for="column in nonCompoundColumns"
        :key="column.field"
        :sortable="true"
        v-bind="column"
      >
        <span :class="column.numeric ? 'smaller' : ''">
          <template v-if="column.field === 'FG'">
            {{ props.row.FGM }}/{{ props.row.FGA }} ({{ props.row['FG%'] }}%)
          </template>
          <template v-else-if="column.field === '3PT'">
            {{ props.row['3ptM'] }}/{{ props.row['3ptA']}} ({{ props.row['3P%']}}%)
          </template>
          <template v-else-if="column.field === 'FT'">
            {{ props.row['FTM'] }}/{{ props.row['FTA'] }} ({{ props.row['FT%']}}%)
          </template>
          <template v-else-if="['FT%', '3P%', 'FG%'].includes(column.field)">
            {{ props.row[column.field].toFixed(1) }}%
          </template>
          <template v-else-if="column.field === 'PlusMinus'">
            <span
              :class="props.row['PlusMinus'] >= 0 ? 'green' : 'red'"
            >
              {{ props.row['PlusMinus'] }}
            </span>
          </template>
          <template v-else>
            {{ props.row[column.field] }}
          </template>
        </span>
      </b-table-column>
    </template>
    <template slot="footer">
      <td class="summary" v-for="column in nonCompoundColumns" :key="column.field">
        <div
          class="th-wrap has-text-weight-bold"
          :class="column.numeric && 'has-text-right'"
        >
          <template v-if="column.field === 'FG'">
            {{ summary.FGM }}/{{ summary.FGA }} ({{ summary['FG%'] }}%)
          </template>
          <template v-else-if="column.field === '3PT'">
            {{ summary['3ptM'] }}/{{ summary['3ptA']}} ({{ summary['3P%']}}%)
          </template>
          <template v-else-if="column.field === 'FT'">
            {{ summary['FTM'] }}/{{ summary['FTA'] }} ({{ summary['FT%']}}%)
          </template>
          <template v-else-if="['FT%', '3P%', 'FG%'].includes(column.field)">
            {{ summary[column.field].toFixed(1) }}%
          </template>
          <template v-else>
            {{ summary[column.field] }}
          </template>
        </div>
      </td>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'Boxscore',
  props: {
    boxscore: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    summary: {
      type: Object,
      required: true,
    },
  },
  computed: {
    nonCompoundColumns () {
      return this.columns.filter((column) => (column.visible === undefined ? true : column.visible))
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ tr {
  line-height: 16px;
}

/deep/ td, /deep/ th {
  padding: 6px 2px !important;
}

/deep/ .table-footer {
  color: #333;
  text-transform: uppercase;
}

/deep/ table {
  max-width: 1200px !important;
}

.smaller {
  font-size: 0.9rem;
  text-align: center;
}

.green {
  color: green;
}

.red {
  color: red;
}

.muted > td {
  opacity: 0.7;
}
</style>
